<template>
  <div 
    v-if="funding.length"
  >
    <h2 v-if="!sidebar">
      Funding Breakdown
    </h2>
    <div class="flex flex-wrap">
      <funding-split-allocation
        :allocation="allocation"
        class="w-full" 
        :class="{
          'md:w-2/3 md:pr-24' : !sidebar,
          'pb-12' : sidebar
        }"
      />
      <funding-split-breakdown
        :breakdown="breakdown"
        class="w-full"
        :class="{
          'md:w-1/3' : !sidebar
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FundingSplit',
  props: {
    funding: {
      type: Array,
      required: true
    },
    sidebar: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    breakdown() {
      return this.funding.reduce((total, {grant_balance}) => {
        total.remaining+= (grant_balance.remaining - grant_balance.requested)
        total.used+= grant_balance.used
        total.requested+= grant_balance.requested
        return total
      }, { remaining: 0, used: 0, requested: 0})
    },
    allocation() {
      return this.funding.reduce((arr, {company, grant_balance}) => {
        let companyLabel = company.name.length > 16 ? company.name.substring(0,15) + '...' : company.name;
        arr.push({
          name: companyLabel,
          total: (grant_balance.remaining + grant_balance.used + grant_balance.requested),
          remaining: (grant_balance.remaining - grant_balance.requested),
          used: grant_balance.used,
          requested: grant_balance.requested
        })
        return arr
      }, []).sort((a, b) => a.total < b.total ? 1 : -1)
    }
  }
}
</script>
